export var MedicationsPermissions;
(function (MedicationsPermissions) {
    MedicationsPermissions["ModuleOneCode"] = "Medications";
    MedicationsPermissions["AccessCode"] = "Medications_Access";
    MedicationsPermissions["WritePharmacyRequest"] = "Medications_WritePharmacyRequest";
    MedicationsPermissions["ReadMedicationLists"] = "Medications_ReadMedicationLists";
    MedicationsPermissions["WriteMedicationLists"] = "Medications_WriteMedicationLists";
    MedicationsPermissions["PrescribeMedicationsTakeHomeScript"] = "Medications_PrescribeMedicationsTakeHomeScript";
    MedicationsPermissions["PrescribeMedicationsMedicationOrder"] = "Medications_PrescribeMedicationsMedicationOrder";
    MedicationsPermissions["PrescribeMedicationsMedicationHistory"] = "Medications_PrescribeMedicationsMedicationHistory";
    MedicationsPermissions["PrescribeMedicationsEnrmcScript"] = "Medications_PrescribeMedicationsAgeDisabilityScript";
    MedicationsPermissions["PrescribeComplementaryTherapyOrder"] = "Medications_PrescribeComplementaryTherapyOrder";
    MedicationsPermissions["StopMedications"] = "Medications_StopMedications";
    MedicationsPermissions["WriteUsers"] = "ResourceManagement_WriteUsers";
    MedicationsPermissions["WriteStaffMembers"] = "ResourceManagement_WriteStaffMembers";
    MedicationsPermissions["EncounterPerform"] = "Encounter_Perform";
})(MedicationsPermissions || (MedicationsPermissions = {}));
